import { Group, Stack, Text } from "@mantine/core";


type Props = {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
};

export function SectionTitle({ title, subtitle, children }: Readonly<Props>) {
  return (
    <Group justify="space-between">
      <Stack gap={4}>
        <Text fz={'h3'} fw={700} lh={'normal'}>{title}</Text>
        {subtitle && <Text c={'var(--text-muted)'} fz={'sm'} lh={'normal'}>{subtitle}</Text>}
      </Stack>
      {children}
    </Group>
  );
}
